<h2 mat-dialog-title>Edit User</h2>

<mat-dialog-content>
    <form [formGroup]="editForm" class="edit-form">

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Display Name</mat-label>
            <input matInput formControlName="name">
            <mat-error *ngIf="editForm.get('name')?.hasError('required')">
                Name is required
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email (Login ID)</mat-label>
            <input matInput formControlName="email">
            <mat-error *ngIf="editForm.get('email')?.hasError('required')">
                Email is required
            </mat-error>
            <mat-error *ngIf="editForm.get('email')?.hasError('email')">
                Invalid email format
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>New Password (Optional)</mat-label>
            <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
                placeholder="Leave blank to keep current">
            <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
                <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Authority</mat-label>
            <mat-select formControlName="authority">
                <mat-option value="admin">Admin (管理者)</mat-option>
                <mat-option value="user">User (一般)</mat-option>
            </mat-select>
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" [disabled]="editForm.invalid" (click)="onSubmit()">
        Save
    </button>
</mat-dialog-actions>